<div class="my-3 bg">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="text-center">
          <div class="mb-2">
            <a routerLink="">
              <img src="assets/Gypsee_Logo_1-01 (1).png" alt="logo" height="100"/>
            </a>
          </div>

          <div class="row justify-content-center">
            <div class="col-lg-6">
              <div class="card">
                <div class="row no-gutters align-items-center">
                  <div class="col-md-4">
                    <img class="card-img img-fluid pl-sm-3 pt-sm-3"
                         src="https://res.cloudinary.com/gypsee-ai/image/upload/v1622054143/user-images/lfbbedr7qj6qhbxfdhfw.jpg"
                         alt="Shop Logo">
                  </div>
                  <div class="col-md-8 text-left">
                    <div class="card-body pt-md-0">
                      <div class="card-title">Dilip Driving School</div>
                      <p class="card-text mb-0">Contact: 9550581358</p>
                      <p class="card-text">HSR layout, banglore.</p>
                    </div>
                  </div>
                  <div class="card-body">
                    <div class="card-title mt-0">Book Your Desired Slot</div>
                    <div class="text-left">
                      <div class="form-group">
                        <label for="timeslotSelect" class="">Time Slot</label>
                        <ng-select [(ngModel)]="selectedTimeSlot" class=" col-md-8 p-0" id="timeslotSelect"
                                   placeholder="Select A Time Slot">
                          <ng-option *ngFor="let timeSlot of availableTimeSlots"
                                     [value]="timeSlot">{{timeSlot}}</ng-option>
                        </ng-select>
                      </div>
                      <div class="form-group">
                        <label for="fullName">Full Name</label>
                        <input type="text" class="form-control  col-md-8" id="fullName"
                               placeholder="Enter your Name">
                      </div>
                      <div class="form-group">
                        <label for="contactNumber">Contact Number</label>
                        <input [mask]="'0000000000'" class="form-control col-md-8" id="contactNumber"
                               aria-describedby="contactNumber"
                               placeholder="Enter Phone Number">
                      </div>
                      <div class="form-group">
                        <label for="exampleInputEmail1">Email address</label>
                        <input type="email" class="form-control col-md-8" id="exampleInputEmail1"
                               aria-describedby="emailHelp"
                               placeholder="Enter email">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row d-flex justify-content-center pb-4">
                  <button mat-button class="btn btn-solid-blue">Submit</button>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
